// Billing presentation primitives — Invoice type + STATUS_PILL map +
// formatRupees + fmtDate helper. Replaces components/InvoiceRow.tsx
// which housed these exports until TASK-N33 deleted the row component.

// docs/24 — "refunded"/"failed" are set by the inbound nsofar invoice-events webhook.
export type InvoiceStatus = "draft" | "issued" | "paid" | "overdue" | "cancelled" | "refunded" | "failed";

export interface Invoice {
  _id:            string;
  patient_id:     string;
  sr_id:          string | null;
  invoice_number: string;
  amount_paise:   number;
  status:         InvoiceStatus;
  issued_at:      string | null;
  due_date:       string | null;
  paid_at:        string | null;
  payment_method: string | null;
  notes?:         string;
  // docs/24 nsofar-rendered artifacts (present on agency-invoicing invoices).
  nsofar_invoice_number?: string | null;
  invoice_pdf_url?: string | null;
  invoice_view_url?: string | null;
  receipt_url?: string | null;
}

export const STATUS_PILL: Record<Invoice["status"], string> = {
  draft:     "bg-slate-100 text-slate-600",
  issued:    "bg-blue-100 text-blue-700",
  paid:      "bg-green-100 text-green-700",
  overdue:   "bg-red-100 text-red-700",
  cancelled: "bg-slate-200 text-slate-500",
  refunded:  "bg-amber-100 text-amber-700",
  failed:    "bg-red-100 text-red-700",
};

export function formatRupees(paise: number): string {
  return (paise / 100).toLocaleString("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 });
}

export function fmtDate(iso: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-IN", { dateStyle: "medium" });
}
